import styled from "styled-components";

interface IContainer {
  hasError?: any;
  height?: string;
  width?: string;
  TagInputWidth?: boolean;
}
export const Container = styled.div<IContainer>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
  `}
  background-color: ${(props) => props.theme.colors.white};
  -ms-overflow-style: none;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
  display: flex;
  font-size: 1.5rem;
  font-weight: 500;
  height: "auto"};
  min-height: 4.5rem;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0 0.5rem;
  scrollbar-width: none;
  width: ${(props) => props.width ?? "32.8rem"};
  max-width:${(props) =>
    props.width && props.TagInputWidth ? "none" : "38rem"};

  &::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: flex;
    margin: 0;
    padding: 0;

    li {
      align-items: center;
      display: flex;
      list-style: none;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }

    .tag {
      ${(props) => `
        background-color: ${
          props.hasError
            ? props.theme.colors.backgroundRed
            : "rgba(23, 21, 120, 0.1)"
        };
      `}
      border-radius: 8px;
      box-sizing: border-box;
      height: 3rem;
      padding: 0.3rem 0.8rem;

      button {
        background: none;
        border: none;
        margin-left: 1rem;
        padding: 0;
      }
    }

    input:focus {
      outline: none;
    }
  }
  .flex-align-center {
    display: flex;
    align-items: center;
  }
  .font-size-li {
    font-size: 1.4rem;
  }
`;

export const SpecialInput = styled.input`
  border: none;
  font: inherit;
  padding-right: 1rem;
  height: ${(props) => (props.height ? props.height : "3rem")};
  width: ${(props) => props.width};
`;
